import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';

import Home from './pages/Home';
import TailgateCentral from './pages/TailgateCentral';
import Blog from './pages/Blog';
import FirstSnap from './pages/FirstSnap';
import Playlists from './pages/Playlists';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclosure from './pages/Disclosure';
import Merch1 from './pages/Merch1';
import Merch from './pages/Merch';
import Header from './components/Header';
import Footer from './components/Footer';
import StickySpotify from './components/StickySpotify';
import TopTicker from './components/TopTicker.jsx';
import InviteRedirector from './components/InviteRedirector.jsx';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <InviteRedirector />
          <TopTicker />
          <StickySpotify />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tailgate-central" element={
              <div>
                <Header />
                <TailgateCentral />
                <Footer />
              </div>
            } />
            {/* Blog route hidden - not ready for public viewing
            <Route path="/blog" element={
              <div>
                <Header />
                <Blog />
                <Footer />
              </div>
            } />
            */}
            {/* First Snap route hidden - not ready for production
            <Route path="/first-snap" element={
              <div>
                <Header />
                <FirstSnap />
                <Footer />
              </div>
            } />
            */}
            <Route path="/playlists" element={
              <div>
                <Header />
                <Playlists />
                <Footer />
              </div>
            } />
            <Route path="/about" element={
              <div>
                <Header />
                <About />
                <Footer />
              </div>
            } />
            <Route path="/privacy" element={
              <div>
                <Header />
                <Privacy />
                <Footer />
              </div>
            } />
            <Route path="/terms" element={
              <div>
                <Header />
                <Terms />
                <Footer />
              </div>
            } />
            <Route path="/disclosure" element={
              <div>
                <Header />
                <Disclosure />
                <Footer />
              </div>
            } />
            <Route path="/merch" element={<Merch />} />
            {/* Merch1 route hidden - old merch page
            <Route path="/merch1" element={
              <div>
                <Header />
                <Merch1 />
                <Footer />
              </div>
            } />
            */}
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App; 